/** User-facing copy aligned with docs/GEN_LOS_Opportunity_FieldSpec_Updated.xlsx */

export const OPPORTUNITY_SUBMIT_INCOMPLETE_FIELDS =
  'Please complete all mandatory fields before submitting.';

export const OPPORTUNITY_CONFIRMATION_RM_PENDING =
  'Opportunity created, but RM assignment is pending - it will be auto-assigned shortly.';

export const OPPORTUNITY_BUREAU_INVALID_PAN_INDIVIDUAL =
  'Invalid PAN format - expected format: ABCDE1234F.';

export const OPPORTUNITY_BUREAU_INVALID_PAN_CORPORATE =
  'Invalid PAN format - expected format: AAACA1234D.';

export const OPPORTUNITY_BUREAU_INVALID_IDENTITY =
  'Enter a valid identity document number.';

export const OPPORTUNITY_SEARCH_INVALID_NAME = 'Enter a valid Name.';

export const OPPORTUNITY_SEARCH_INVALID_DOB = 'Enter a valid Date of Birth.';

export const OPPORTUNITY_SEARCH_NAME_REQUIRES_DOB =
  'Please enter the DOB with Name';

export const OPPORTUNITY_SEARCH_DOB_REQUIRES_NAME =
  'Please enter Name with DOB';

export const OPPORTUNITY_SEARCH_INVALID_PAN_INDIVIDUAL =
  OPPORTUNITY_BUREAU_INVALID_PAN_INDIVIDUAL;

export const OPPORTUNITY_SEARCH_INVALID_PAN_CORPORATE =
  OPPORTUNITY_BUREAU_INVALID_PAN_CORPORATE;

export const OPPORTUNITY_SEARCH_INVALID_AADHAAR =
  'Enter a valid 12-digit Aadhaar Number.';

export const OPPORTUNITY_SEARCH_INVALID_CONTACT =
  'Enter a valid 10-digit Contact Number.';

export const OPPORTUNITY_SEARCH_INVALID_ORGANISATION =
  'Enter a valid Organisation Name.';

export const OPPORTUNITY_SEARCH_INVALID_CIN_GSTIN =
  'Enter a valid CIN or GSTIN.';

export const OPPORTUNITY_SEARCH_INVALID_INCORPORATION_DATE =
  'Enter a valid Date of Incorporation.';

export const OPPORTUNITY_DRAFT_SAVED_TITLE = 'Draft Saved Successfully';

export const OPPORTUNITY_DRAFT_SAVED_MESSAGE =
  'Your opportunity draft has been saved';

export const OPPORTUNITY_CONVERT_APPLICATION_CREATED =
  'Application created successfully.';

export const OPPORTUNITY_CONVERT_DEFERRED =
  'Conversion accepted — processing deferred';

export const OPPORTUNITY_ASSIGN_RM_SUCCESS =
  'Opportunity assigned successfully.';

export const OPPORTUNITY_REJECT_SUCCESS = 'Opportunity rejected successfully.';
